import { Injectable, OnDestroy } from '@angular/core';
import { CompareCartService } from '@cart/data-access';
import { CustomBasePageMetaResolver } from '@core/feature';
import {
  BreadcrumbMeta,
  CanonicalPageResolver,
  CmsService,
  Page,
  PageBreadcrumbResolver,
  PageDescriptionResolver,
  PageMetaResolver,
  PageRobotsMeta,
  PageRobotsResolver,
  PageTitleResolver,
  PageType,
  PageTypeResolver,
} from '@spartacus/core';
import { Observable, Subscription } from 'rxjs';
import { distinctUntilKeyChanged, filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CustomCartPageMetaResolver
  extends PageMetaResolver
  implements
    PageTitleResolver,
    PageBreadcrumbResolver,
    PageDescriptionResolver,
    PageRobotsResolver,
    CanonicalPageResolver,
    PageTypeResolver,
    OnDestroy
{
  sub: Subscription;

  constructor(
    private basePageMetaResolver: CustomBasePageMetaResolver,
    private compareCartService: CompareCartService,
    private cms: CmsService,
  ) {
    super();
    this.pageType = PageType.CONTENT_PAGE;

    if (!this.sub) {
      this.sub = this.resolveValidation().subscribe();
    }
  }

  resolveTitle(): Observable<string | undefined> {
    return this.basePageMetaResolver.resolveTitle();
  }

  resolveBreadcrumbs(): Observable<BreadcrumbMeta[]> {
    return this.basePageMetaResolver.resolveBreadcrumbs();
  }

  resolveDescription(): Observable<string | undefined> {
    return this.basePageMetaResolver.resolveDescription();
  }

  resolveRobots(): Observable<PageRobotsMeta[]> {
    return this.basePageMetaResolver.resolveRobots();
  }

  resolveCanonicalUrl(): Observable<string | undefined> {
    return this.basePageMetaResolver.resolveCanonicalUrl();
  }

  resolveType(): Observable<string> {
    return this.basePageMetaResolver.resolveType();
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  private resolveValidation(): Observable<void> {
    return this.cms.getCurrentPage().pipe(
      filter<Page>(Boolean),
      distinctUntilKeyChanged('pageId'),
      filter((page: Page) => page.pageId === 'cartPage'),
      map(() => {
        this.compareCartService.validateCart();
      }),
    );
  }
}
